import { useMemo, useState, useCallback } from 'react';
import BREADCRUMB_NAMES from '../../../constants/breadcrumbNames';
import { routeConstants } from '../../../constants/routeConstants';

const useManageAreaTaxLocation = () => {
  const {
    SETTINGS: { MANAGE_AREA_TAX_LOCATION, SETTINGS },
  } = BREADCRUMB_NAMES;

  const breadcrumbData = useMemo(
    () => [
      { text: SETTINGS, redirection: routeConstants.SETTING_ROUTE },
      { text: MANAGE_AREA_TAX_LOCATION, redirection: routeConstants.MANAGE_AREA_TAX_LOCATION },
    ],
    [SETTINGS, MANAGE_AREA_TAX_LOCATION],
  );

  const [currentTotalCount, setCurrentTotalCount] = useState(0);

  const handleTotalCountUpdate = useCallback((status, count) => {
    setCurrentTotalCount(count || 0);
  }, []);

  return {
    breadcrumbData,
    currentTotalCount,
    handleTotalCountUpdate,
  };
};

export default useManageAreaTaxLocation;
